import { useNavigate } from "react-router"
// import { ManageStaffLocationTable, StaffTable, } from "ft-shared-graphql"
import { LocationDataType } from "../../context/LocationContext/LocationProvider"

type ManageLocationStaffProps = {
    onBack: () => void
    onSelectedPerson: (id: string, action: string) => void
    location: LocationDataType
}
export const ManageLocationStaffPage = ({ onBack, onSelectedPerson, location }: ManageLocationStaffProps) => {
    return (
        // <ManageStaffLocationTable
        //     onBack={onBack}
        //     locationName={location?.name}
        // />
        <div> placeholder</div>
        // <StaffTable
        //     title={`Manage Staff`}
        //     onBack={onBack}
        //     onSelectedPerson={onSelectedPerson}
        // />
    )
}